// Copyright 2023 Sorama B.V.
import { DialogController } from "aurelia-dialog";
import { autoinject } from "aurelia-framework";

export interface ErrorDialogModel {
    title?: string;
    text?: string;
    itemList?: string[];
    closeText?: string;
}

@autoinject
export class ErrorDialog {
    // The default model
    private model: ErrorDialogModel = {
        title: "An error occurred",
        text: "Please contact Sorama support",
        closeText: "Close",
    };

    constructor(private readonly controller: DialogController) {}

    public activate(errorDialogModel: ErrorDialogModel) {
        // Overwrite the default properties if the property exists in the passed confirmationModel
        this.model = { ...this.model, ...errorDialogModel };
    }

    protected close(): void {
        this.controller.close(true);
    }
}
